import { NAMESPACE as GLOBAL_NAMESPACE } from '../../constants';
import constants from './constants';

const PREFIX = `${GLOBAL_NAMESPACE}/${constants.NAMESPACE}`;

const MOBILE_APP_SELECTION_FETCH_FILES = `${PREFIX}/FETCH_FILES` as const;

export default {
  MOBILE_APP_SELECTION_FETCH_FILES,
};
